import { ENV_PRODUCTION } from './env'
export default process.env.NODE_ENV !== ENV_PRODUCTION
